'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      shape = _baseTheme$vstui.shape,
      shadow = _baseTheme$vstui.shadow,
      cloud3 = color.cloud.getShade(3);
  return (0, _themes.createComponentTheme)(baseTheme, {
    Card_padding: 0,
    Card_backgroundColor: color.surface,
    Card_borderColor: cloud3,
    Card_borderRadius: shape.borderRadius,
    Card_borderStyle: shape.borderStyle,
    Card_borderStyle_raised: 'none',
    Card_borderWidth: shape.borderWidth,
    Card_boxShadow: 'none',
    Card_boxShadow_hover: 'none',
    Card_boxShadow_raised: shadow.low,
    Card_boxShadow_raised_hover: shadow.low,
    Card_boxShadow_raisedInteractive_hover: shadow.high
  });
};

exports.default = componentTheme;